import { render } from "./SignupReview.vue?vue&type=template&id=2129d6f3&scoped=true"
import script from "./SignupReview.vue?vue&type=script&lang=js"
export * from "./SignupReview.vue?vue&type=script&lang=js"

import "./SignupReview.vue?vue&type=style&index=0&id=2129d6f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2129d6f3"]])

export default __exports__